exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-3ca7d58c],html[data-v-3ca7d58c]{height:100%}img[data-v-3ca7d58c]{max-width:400px}", ""]);

// exports
